module.exports = __webpack_public_path__ + "img/abrazo.d87b0836.svg";